import { render, staticRenderFns } from "./Fifth.vue?vue&type=template&id=7c281b4c&"
import script from "./Fifth.vue?vue&type=script&lang=ts&"
export * from "./Fifth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports